import React, { useMemo } from 'react';
import { FileDown, FolderOpen, Loader2 } from 'lucide-react';
import { formatBytes, formatDatum } from '../../../services/sifa/kundenportalLogic';
import type { KundenportalDaten, PortalDateiArt } from '../../../services/sifa/kundenportalTypes';
import { HINWEISKASTEN } from '../public/teilnahmeSeiteStil';
import { gruppiereDokumente } from './kundenportalSeiteLogic';

/** Dokumente der Ablage je Kategorie (ohne Admin-Schloss), Download ueber den Endpunkt. */
export const DokumenteTab: React.FC<{
  daten: KundenportalDaten;
  dateiBusyId: string | null;
  onDatei: (art: PortalDateiArt, id: string) => void;
}> = ({ daten, dateiBusyId, onDatei }) => {
  const gruppen = useMemo(() => gruppiereDokumente(daten.dokumente), [daten.dokumente]);

  if (gruppen.length === 0) {
    return <div className={HINWEISKASTEN}>Es sind noch keine Dokumente für Sie abgelegt.</div>;
  }

  return (
    <div className="space-y-5">
      {gruppen.map((g) => (
        <section key={g.kategorie} className="space-y-2">
          <h2 className="text-sm font-black uppercase tracking-wide text-slate-400 flex items-center gap-2">
            <FolderOpen className="w-4 h-4" /> {g.label} <span className="text-slate-300 font-semibold">({g.dokumente.length})</span>
          </h2>
          <ul className="divide-y divide-slate-100 border border-slate-200 rounded-xl overflow-hidden">
            {g.dokumente.map((d) => (
              <li key={d.id} className="p-3 flex items-center gap-3">
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-slate-800 truncate">{d.titel || d.dateiname}</p>
                  <p className="text-xs text-slate-500 truncate">
                    {[d.ordner, d.stand ? `Stand ${d.stand}` : null, formatDatum(d.createdAt), formatBytes(d.groesseBytes), d.gueltigBis ? `gültig bis ${formatDatum(d.gueltigBis)}` : null]
                      .filter(Boolean)
                      .join(' · ')}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => onDatei('dokument', d.id)}
                  disabled={!!dateiBusyId}
                  title={`${d.dateiname} herunterladen`}
                  className="min-h-[44px] px-3 flex items-center gap-1.5 text-xs font-semibold rounded-lg text-blue-700 bg-blue-50 hover:bg-blue-100 disabled:opacity-50 shrink-0"
                >
                  {dateiBusyId === d.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
                  <span className="hidden sm:inline">Herunterladen</span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};
